// @ts-nocheck
import React, { useContext } from 'react';
import { Button, Container, Row, Col, Navbar, LinkList, NavItem, NavLink, Icon, Section, CalloutTitle, CalloutText, Callout } from 'design-react-kit';

import { Service, ServiceContentsSections, ServiceContentsSectionsDataTag } from "../models/service";
import parse from 'html-react-parser';
import ActaAuthUtils from 'pa_kit/utils';
import env from 'env';
import { ActaAuthContext } from 'pa_kit/auth';



const ServiceContentsView = (props) => {

	const service = props.service;

	const auth = useContext(ActaAuthContext);
	const user = auth.user;
	const organization = auth.organization;
	const sportellodigitale_config = organization.active_licenses?.services?.sportellodigitale;
	const assistenza_config = organization.active_licenses?.services?.assistenza;
	const auth_config = auth.organization.active_licenses?.services?.auth;

	return (   
	  <Container fluid className="mb-5">
	  	<Row>
	  		<Col lg="4">
			  	<div className='sticky-wrapper navbar-wrapper'>
			      <Navbar expand='lg' className='it-navscroll-wrapper it-top-navscroll'>
			        <div className='menu-wrapper service-sidebar-menu'>
						<LinkList
							wrapperClassName='menu-link-list'
							header={<h3>Indice della pagina</h3>}
							data-element="page-index"
						>
							{ Object.keys(ServiceContentsSections).map((key, index) => service?.contents[key] &&
								<NavItem key={"key_sectionlink_" + key} >
									<NavLink href={"#" + key}>{Object.values(ServiceContentsSections)[index]}</NavLink>
								</NavItem>
							)}
				  	   	</LinkList>
			  		</div>
			      </Navbar>
			    </div>
			</Col>
		  	<Col lg="8">
			  <Container>
				  { Object.keys(ServiceContentsSections).map((key, index) => service?.contents[key] && 
					  <Row key={"content_link_" + key} id={key} className="service-content-list-item mb-4">
						  <Section color={key === "access" ? "muted" : undefined} style={{ padding: "10px"}}>
						  	<Container>
							  <h4 className="service-content-title">{ Object.values(ServiceContentsSections)[index] }</h4>
							  { service.contents[key]?.description && (
								  <div className="service-content-description" data-element={(ServiceContentsSectionsDataTag)[key]}>
									{ parse(service.contents[key].description) }
								  </div>
							  )}
							  { service.contents[key]?.attachments && (
								  <div className="mt-4">
									  { service.contents[key].attachments.map((attachment) => 
											  <p className="service-content-link">
											  	<a href={attachment.url}><Icon icon="it-clip" /> {attachment.name}</a>
											  </p>
									  ) }
								  </div>
							  )}
							  { service.contents[key]?.links && (
								  <div className="mt-4">
									  { service.contents[key].links.map((link) => 
											  <p className="service-content-link"><Icon icon="it-link" /> <a href={link.url}>{link.title}</a></p>
									  ) }
								  </div>
							  )}
							  { service.contents[key]?.timeline && (
								  <div className="mt-5">
									  { service.contents[key].timeline.map((event) => 
									  		  <>
									  		  <div className="step" data-element="service-calendar-list">
											  	<div className="date-step d-inline">
											  		<span className="date-step-giorno">{event.date}</span>
											  		<span className="pallino"></span>
											  	</div>
											  	<div className="scheda-step d-inline">
											  		<span className="scheda-step-testo">{event.description}</span>
											  	</div>
											  </div>
											  </>
									  ) }
								  </div>
							  )}
							  { (key === "access" || service.contents[key]?.ctas) && (
								  <div className="mt-3 mb-5">
									  { key === "access" && (
										  <p>											  
											  {!user && service.modules.length !== 0 &&
													<Button size='lg' color='primary' data-element="service-online-access" icon onClick={() => ActaAuthUtils.login(auth_config, sportellodigitale_config.frontend_url + "module/" + service.modules[0].id)}>
														Accedi
													</Button>
											  }
											  {user && service.modules.map((module) => 
													<div className="mb-2">
														{/***
														<Button data-element="service-online-access" className="service-content-btn" color='success' size='lg' href={"/module/" + module.id} >{module.name}</Button>
											  			
														<button data-element="service-online-access" onClick={() => window.open("/module/" + module.id)} className="service-content-btn btn btn-success btn-lg">
															{module.name}
														</button>
														***/}

														<Button size='lg' color='primary' data-element="service-online-access" onClick={() => window.open(sportellodigitale_config.frontend_url + "module/" + module.id, "_self")} >
															{module.name}
														</Button>
													</div>
											  )}
										  </p>
									  )}
									  { service.contents[key]?.ctas && service.contents[key].ctas.map((cta) => 
										  <p>
											  <div>
												{parse(cta.description)}
											  </div>
											  <Button color='primary' size='lg' onClick={()=> window.open(cta.url, '_blank')}>{cta.title}</Button>
										  </p>
									  )}
									  {assistenza_config?.frontend_url && 
										<p>
											<div className="mb-2">
												Oppure, puoi prenotare un appuntamento e presentarti presso gli uffici.
											</div>
											{service.contents.contacts?.contacts[0] && service.contents.contacts.contacts[0]?.slug
												? <Button outline color='primary' size='lg' onClick={()=> window.open(assistenza_config.frontend_url + '?office=' + service.contents.contacts.contacts[0]?.slug + '&reason=' + service.name, '_self')} data-element="service-booking-access">Prenota un appuntamento</Button>
												: <Button outline color='primary' size='lg' onClick={()=> window.open(assistenza_config.frontend_url + '?reason=' + service.name, '_self')} data-element="service-booking-access">Prenota un appuntamento</Button>
											}											
										</p>
									  }
								  </div>
							  )}
							  { (key === "terms") && (
								  <div className="mt-3 mb-5">
									<Button data-element="service-file" color='primary' size='lg' onClick={()=> window.open(service.contents[key].url ?? env.AUTH_BACKEND_BASE_URL + 'media/organization/termini_condizioni.pdf', '_blank')}>Termini e condizioni di servizio</Button>
								  </div>
							  )}
							  { service.contents[key]?.contacts && (
								  <div className="mt-3">
									  { service.contents[key].contacts.map((contact) => 
									  	<>
									  		  <Callout highlight>
												<CalloutTitle data-element="service-area">
													<Icon icon="it-pa"/><strong>{contact.name}</strong>
												</CalloutTitle>
												<CalloutText>
													<p>
														{parse(contact.description)}
													</p>
													<p>
														Tel: {contact.telephone_1}<br/>
														Cell: {contact.telephone_2}<br/>
														Email: {contact.email}<br/>
														PEC: {contact.pec}<br/>
													</p>
													{ contact.url && (
														<a href={contact.url}className='text-decoration-none' >
															Scopri di più
															<Icon icon="it-arrow-right"/>
														</a>													  
													)}
												</CalloutText>
											  </Callout>
										</>
									  ) }
								  </div>
							  )}
							  </Container>
						  </Section>
					  </Row>
				  )}
			  </Container>
		  	</Col>
		</Row>
	  </Container>
	);
}
export default ServiceContentsView;
